import { render, staticRenderFns } from "./options.vue?vue&type=template&id=65e18806"
import script from "./options.vue?vue&type=script&lang=js"
export * from "./options.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports